export class RouteNames {
    public static readonly home = "home";

    public static readonly createRequest = "create-request";

    public static readonly calendar = "calendar";

    public static readonly createActivation = "createActivation";

    public static readonly editActivation = "editActivation";

    public static readonly showActivation = "showActivation";

    public static readonly brands = "brands";

    public static readonly newBrand = "newBrand";

    public static readonly editBrand = "editBrand";

    public static readonly markets = "markets";

    public static readonly newMarket = "newMarket";

    public static readonly editMarket = "editMarket";

    public static readonly prAffiliates = "prAffiliates";

    public static readonly newPrAffiliate = "newPrAffiliate";

    public static readonly editPrAffiliate= "editPrAffiliate";

    public static readonly about = "about";

    public static readonly unauthorized = "unauthorized";

    public static readonly notFound = "not-found";

    public static readonly adminUser = "admin";
}
